//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ShowCustomReports: FeatureFlag = {"Id":"ShowCustomReports","Label":"[10.24]Show Custom Reports","Impact":"Show the custom Reports dashboard and hide the legacy Stats page. When enabled, the Reports nav/card appear and Stats nav/card are hidden.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
